var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatchUpdates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.00002V13L15.25 15.52L16.02 14.24L12.5 12.15V8.00002H11ZM21 10V3.00002L18.36 5.64002C17.5272 4.80125 16.5362 4.13602 15.4445 3.68286C14.3528 3.2297 13.182 2.99761 12 3.00002C10.22 3.00002 8.47991 3.52786 6.99987 4.51679C5.51983 5.50572 4.36628 6.91133 3.68509 8.55587C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5017 4.37737 17.1053 5.63604 18.364C6.89472 19.6227 8.49836 20.4798 10.2442 20.8271C11.99 21.1744 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0002C20.4722 15.5201 21 13.7801 21 12H19C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14002 8.14 5.00002 12 5.00002C13.93 5.00002 15.68 5.79002 16.95 7.05002L14 10H21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchUpdates);
export default __webpack_public_path__ + "static/media/batchUpdates.dd6e0591e5e04ef018ad3c8b9aa5fef9.svg";
export { ForwardRef as ReactComponent };